class SlideshowComponent extends HTMLElement {
  constructor() {
    super();

    if (window.Glider) {
      this.initGlider();
      this.initThumbnailListeners();
    }
  }

  get gliderOptions() {
    return {
      slidesToShow: 1,
      draggable: true,
      dragVelocity: 2,
      scrollLock: true,
      dots: '#slideshow-dots',
      rewind: true
    }
  }

  initGlider() {
    this.slideshow  = new Glider(
      this.firstElementChild,
      this.gliderOptions
    );
  }

  initThumbnailListeners() {
    const slideshowTray = this.querySelector('.slideshow__tray');
    if (slideshowTray && slideshowTray.children.length) {
      let thumbs = Array.from(slideshowTray.children);
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', this.gotoSlide.bind(this))
      });
    }
  }

  gotoSlide(event) {
    let slideIndex = event.currentTarget.dataset.index;
    this.slideshow.scrollItem(slideIndex, true);
  }
}

window.customElements.define('slideshow-component', SlideshowComponent);
